const apiHost = 'https://api-sandbox.eyefinity.com/lab-laborderapi-web/';

export const environment = {
  production: true,
  envName: 'sandbox',

  apiEndpoint: apiHost + 'laborders/',
  apiLabSearchEndpoint: apiHost + 'labordersearchrequestslab/',
  acsRedirectUrl: 'https://labportal-sandbox.eyefinity.com',
  billerDirectUrl: 'https://secureb.eyefinity.com/ebill',
  vspOnlineUrl: 'https://labportal-sandbox.eyefinity.com/comingSoon.html',
  oauthBaseUrl: 'api-sandbox',
  lensCatalogApiEndpoint:
    'https://api-sandbox.eyefinity.com/cataloglens-consumption-api/',
  dynaTraceUrl: '',
  paymentStatementsApiEndpoint: '',
  labLogonUrl: 'https://smd.eyefinity.com/eyefinity/html/eyefinity_lablogon.htm',
  welcomeLogOutUrl: '/home',
  labRefManualUrl: 'https://www.vsplrm.com/',
};



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/environments/environment.ts